import { Announcement } from '@/types';
import { apiClient } from '../client';

// Admin-only on the backend (see router.go); the UI only renders the "Admin Notify" page
// and nav item for admins, but the backend is the real enforcement point regardless.

export async function listAnnouncements(): Promise<Announcement[]> {
  const { data } = await apiClient.get<Announcement[]>('/announcements');
  return data;
}

export async function createAnnouncement(title: string, image: File, expiresAt?: string): Promise<Announcement> {
  const form = new FormData();
  form.append('title', title);
  form.append('image', image);
  if (expiresAt) form.append('expiresAt', expiresAt);
  const { data } = await apiClient.post<Announcement>('/announcements', form);
  return data;
}

export async function setAnnouncementActive(id: string, active: boolean): Promise<Announcement> {
  const { data } = await apiClient.patch<Announcement>(`/announcements/${id}`, { active });
  return data;
}

export async function deleteAnnouncement(id: string): Promise<void> {
  await apiClient.delete(`/announcements/${id}`);
}

// Open to any logged-in role — these back the login popup, not the admin page.

export async function getActiveAnnouncements(): Promise<Announcement[]> {
  const { data } = await apiClient.get<Announcement[]>('/announcements/active');
  return data;
}

export async function dismissAnnouncement(id: string): Promise<void> {
  await apiClient.post(`/announcements/${id}/dismiss`);
}

/** The backend requires Authorization, which a plain <img src> can't send — fetch as a
 *  blob instead and hand back an object URL. See useAnnouncementImage. */
export async function getAnnouncementImageBlob(id: string): Promise<Blob> {
  const { data } = await apiClient.get(`/announcements/${id}/image`, { responseType: 'blob' });
  return data;
}
